/** @jsxImportSource @emotion/react */
import { AIResponse, Box, Heading, Icon, Text } from '@landtrustinc/design-system';
import React from 'react';

import type { BudgetExhaustedMessage } from '../../types';
import { badgeStyles, containerStyles, iconStyles } from './styles';

type BudgetExhaustedProps = {
  msg: BudgetExhaustedMessage;
};

const BudgetExhausted: React.FC<BudgetExhaustedProps> = ({ msg }) => {
  return (
    <AIResponse key={msg.id} showDisclaimer={false} showHelpfulQuestion={false} showTitle={false}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        css={containerStyles}
      >
        {/* Buck Icon */}
        <Box css={iconStyles}>
          <Icon variant="ConversationalSearchAi" size="large" fill="#fff" />
        </Box>
        {/* Title */}
        <Box mt="var(--spacing-4)">
          <Heading size="sm" fontWeight="bold">
            Buck needs a break
          </Heading>
          <Heading size="2xs">But he&apos;ll be back tomorrow!</Heading>
        </Box>
        {/* Message body */}
        <Box mt="var(--spacing-3)">
          <Text size="md">
            We&apos;ve hit our daily chat limit. Check back tomorrow when Buck is refreshed and
            ready to help.
          </Text>
        </Box>
        {/* Customer support text */}
        <Box mt="var(--spacing-3)">
          <Text size="md" style={{ fontStyle: 'italic' }}>
            Need help now? Our customer support team is always here for you.
          </Text>
        </Box>
        {/* Badge */}
        <Box mt="var(--spacing-4)" css={badgeStyles}>
          Daily Limit Reached
        </Box>
      </Box>
    </AIResponse>
  );
};

export default BudgetExhausted;
